import React from 'react'
import styled from 'styled-components'
import { RegistrationTemplate } from 'spa/member/components/WorkPreference/RegistrationTemplate'
import { FirstForm } from 'spa/member/components/WorkPreference/Registration/FirstForm'
import { SecondForm } from 'spa/member/components/WorkPreference/Registration/SecondForm'
import { ThirdForm } from 'spa/member/components/WorkPreference/Registration/ThirdForm'
import { FourthForm } from 'spa/member/components/WorkPreference/Registration/FourthForm'
import { OnChangeStep } from 'spa/member/components/WorkPreference/Registration/types'

type Props = {
  currentStep: number
  onChangeStep: OnChangeStep
}

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 3rem 1rem;

  @media ${props => props.theme.media.sm} {
    padding: 80px 1rem 100px;
  }
`

export const StyledWorkPreference: React.FC<Props> = (props: Props) => {
  const args = { formType: 'QUESTIONNAIRE', onChangeStep: props.onChangeStep }

  const stepForm = () => {
    switch (props.currentStep) {
      case 1:
        return <FirstForm {...args} />
      case 2:
        return <SecondForm {...args} />
      case 3:
        return <ThirdForm {...args} />
      case 4:
        return <FourthForm {...args} />
      default:
        return <FirstForm {...args} />
    }
  }

  return (
    <StyledContainer>
      <RegistrationTemplate {...props}>
        {stepForm()}
      </RegistrationTemplate>
    </StyledContainer>
  )
}
